module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f6ab.415fa55d.svg";